module.exports = __webpack_public_path__ + "img/btn-gfsq.8809402c.webp";